import type { SVGProps } from 'react'
const SvgSyDelAlt = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<ellipse cx={12} cy={7} fillOpacity={0.24} rx={7} ry={3} />
		<path
			fillRule="evenodd"
			d="M12 10c3.336 0 6.127-1 6.83-2.34.01-.02.06-.006.057.018l-1.775 10.647a1.8 1.8 0 0 1-.646 1.102 7.15 7.15 0 0 1-8.932 0 1.8 1.8 0 0 1-.646-1.102L5.113 7.678c-.004-.024.046-.039.058-.017C5.874 9 8.664 10 12 10"
			clipRule="evenodd"
		/>
	</svg>
)
export default SvgSyDelAlt
